<template>
  <BaseTable
      :title="$t('task_type')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="TaskTypeListQueryDTO"
      dto-save-list-model="TaskTypeSaveListCommandDTO"
      store-name="TaskTypeTable"
      new-item-component="TaskTypeItem"
      new-item-pass="/Product/TaskType/TaskTypeItem"
      :lang-dictionary="function(text) {return $t(text)}"
      hide-default-footer
      fixed-header
  >
    <template v-slot:item.name="{ item }">
      <router-link :to="{name:'TaskTypeItem', params: { itemUid: item.uid}}">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
    <template v-slot:item.group="{ item }">
      {{ $t('groups.' + item.group)}}
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";

export default {
  name: 'TaskTypeTable',
  props: {
    subtractHeight: {type: [Number], default: 80},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {
    BaseTable,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n src=".\locales.json">
</i18n>
